export const sortByDisplayOrder = <T extends { data: { display_order?: number } }>(items: T[]): T[] =>
  items.sort(
    (a, b) => (a.data.display_order ?? Number.MAX_SAFE_INTEGER) - (b.data.display_order ?? Number.MAX_SAFE_INTEGER)
  );
